export default {
    me: {},
    authenticate: false,
    urlBack: 'home'
}